import { Event } from "../Event";

export class UserCpfCnpjEvents extends Event {
  public onBlur = async (
    value: any,
    setField: any,
    setState: any,
    formValues: any
  ) => {};
}
